import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseBrandFormPayload } from '@hooks/useBrand'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

interface ArtworkSettingsProps {
  brandFormPayload: UseBrandFormPayload,
}

const ArtworkSettings = (props: ArtworkSettingsProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      options,
    },
  } = brandFormPayload

  const {
    disable_artwork_download,
    disable_artwork_upload,
    disable_print_quality,
  } = options

  return (
    <DashboardModule title="Artwork Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => (
            toggleNestedValue(brandFormPayload, 'options.disable_artwork_download', { shouldSetState: true })
          )}
          toggleValue={!disable_artwork_download || disable_artwork_download === undefined}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Artwork Download</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies will be able to download the artworks created on the system
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => toggleNestedValue(brandFormPayload, 'options.disable_print_quality', { shouldSetState: true })}
          toggleValue={!disable_print_quality || disable_print_quality === undefined}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Download Print Quality</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies under this brand group will be able to download print quality PDF
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => (
            toggleNestedValue(brandFormPayload, 'options.disable_artwork_upload', { shouldSetState: true })
          )}
          toggleValue={!disable_artwork_upload || disable_artwork_upload === undefined}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Upload Artworks</ToggleListItem.Title>

          <ToggleListItem.Description>
            Agencies will be able to upload custom artworks to orders
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

export default ArtworkSettings
